<template>
    <div id="spotPricingTabs">
        <ejs-tab id="element" ref="spotPricingTabs">
            <e-tabitems>
                <e-tabitem :header='headerText0' :content="spotSummary"></e-tabitem>
                <e-tabitem :header='headerText1' :content="spotPricing"></e-tabitem>
                <e-tabitem v-if="hasSpotLogsPermission" :header='headerText2' :content="spotPricingLogs"></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from "vue";
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import SpotPricing from '@/views/markets/spotTab/SpotPricing.vue';
    import SpotPricingLogs from '@/views/markets/spotTab/SpotPricingLogs.vue';
    import SpotSummary from '@/views/markets/spotTab/SpotSummary.vue';


    Vue.use(TabPlugin);
    export default Vue.extend({
        name: 'spotPricingTabs',
        computed: {
            hasSpotLogsPermission() {
                return this.$store.state.permissions["Permissions.SpotLogs.View"];
            }
        },
        data: function () {
            return {
                headerText0: { text: 'Spot Summary' },
                headerText1: { text: 'Spot' },
                headerText2: { text: 'Spot logs' },

                spotSummary: function () {
                    return {
                        template: {
                            extends: SpotSummary
                        }

                    }
                },
                spotPricing: function () {
                    return {
                        template: {
                            extends: SpotPricing
                        }

                    }
                },
                spotPricingLogs: function () {
                    return {
                        template: {
                            extends: SpotPricingLogs
                        }

                    }
                }

            };
        },
        mounted: function () {


        },

    });
</script>
<style>
    .market-container {
        width: 100%;
        display: flex;
        background-color: white;
        padding-top: 30px;
    }

    .dashboard-seo #marketSummaryLayout.e-dashboardlayout.e-control .e-panel .e-panel-container .e-panel-header {
        border-bottom: 2px solid #e6e9ed !important;
        padding: 10px;
        height: 35px;
        margin: 0 15px 0 15px;
    }

    .dashboard-seo #marketSummaryLayout.e-dashboardlayout .e-panel-content {
        height: calc(100% - 35px) !important;
        overflow: hidden;
        width: 100%;
    }

    #layout_0 {
        width: 492.667px !important;
        background-color: inherit;
        border: none !important;
    }

    #layout_1 {
        width: 492.667px !important;
        left: 489.667px !important;
        background-color: inherit !important;
        border: none !important;
    }

    #layout_2 {
        width: 600px !important;
        left: 979.33px !important;
        background-color: inherit !important;
        border: none !important;
    }

    .e-dashboardlayout.e-control .e-panel {
        box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%) !important;
    }

    .market-crow {
        padding-top: 10px;
    }
</style>